import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from "@/utils/cn";
import { cva } from "class-variance-authority";
const progressVariants = cva("h-full w-full flex-1 transition-all", {
    variants: {
        indicatorColor: {
            primary: "bg-(--primary)",
            muted: "bg-(--muted)",
            destructive: "bg-(--red)",
            success: "bg-(--green)",
            warning: "bg-(--yellow)"
        }
    },
    defaultVariants: {
        indicatorColor: "primary"
    }
});
function Progress({ className, value = 0, ticks, indicatorColor, indicatorClassName, ...props }) {
    return (React.createElement("div", { className: "relative h-4" },
        ticks &&
            ticks.map((tick, i) => (React.createElement("div", { key: "tick_" + i, className: "absolute top-[-8px] w-[2px] h-[24px] bg-black/50", style: { left: `${tick}%` } }))),
        React.createElement(ProgressPrimitive.Root, { "data-slot": "progress", className: cn("bg-(--border) relative h-2 w-full overflow-hidden rounded-full", className), ...props },
            React.createElement(ProgressPrimitive.Indicator, { "data-slot": "progress-indicator", className: cn(progressVariants({ indicatorColor, className: indicatorClassName })), style: { transform: `translateX(-${100 - (value || 0)}%)` } }))));
}
export { Progress, progressVariants };
